var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"id":"algo-glyph","viewBox":"0 0 400 200"}},[_c('path',{attrs:{"d":_vm.paths,"stroke":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }